/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : MultiSelectTextFieldNTC.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import {
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import PropTypes from "prop-types";

function MultiSelectTextFieldNTC({
  size,
  label,
  optionsList = [],
  selectedValues = [],
  setSelectedValues,
  sltFldStyle,
}) {
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 220,
      },
    },
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValues(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl size={size} variant="standard" sx={sltFldStyle}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selectedValues}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) =>
          selected
            .map((val) => optionsList.find((opt) => opt.value === val)?.label)
            .join(", ")
        }
        MenuProps={menuProps}
      >
        {optionsList?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selectedValues?.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

MultiSelectTextFieldNTC.propTypes = {
  size: PropTypes.string,
  label: PropTypes.string,
  optionsList: PropTypes.array,
  selectedValues: PropTypes.array,
  setSelectedValues: PropTypes.func,
  sltFldStyle: PropTypes.object,
};

export default MultiSelectTextFieldNTC;
